<script setup lang="ts">
import { watchEffect } from "vue";
import { useRoute } from "vue-router";
import { ConfigProvider } from "reka-ui";
import { Toaster } from "@lailailai/ui/sonner";
import { useLocale } from "@/locales/useLocale";
import { resolveLocalizedTitle } from "@/locales/route-title";

const route = useRoute();
const { locale, t } = useLocale();

watchEffect(() => {
  const title = resolveLocalizedTitle(
    route.meta.localizedTitle ?? route.meta.title,
    t("shell.system"),
  );
  document.title = `${title} - ${t("shell.system")}`;
});
</script>

<template>
  <ConfigProvider :locale="locale">
    <RouterView />
    <Toaster position="top-center" rich-colors close-button />
  </ConfigProvider>
</template>
